import React from "react";
import { Link } from "react-router-dom"; // Добавляем импорт Link
import Faq from "react-faq-component";

import ddIcon from "../assets/icons/dd.svg";

const data = {
  rows: [
    {
      title: "How do I pay for my ride?",
      content: `We accept all major credit cards with <span class="helvetia">4%</span> processing fee. We accept cash, Venmo, or Zelle, payment must be made within <span class="helvetia">24</span> hours upon arrival.`,
    },
    {
      title: "What if my flight is delayed?",
      content:
        "We will always ask for your flight information when arranging an airport pickup. Our team will monitor the schedule and be there when your plane lands, whether early, late, or on time.",
    },
    {
      title: "Can I make changes to my reservation after it has been confirmed?",
      content: `Yes, you can make changes to your reservation at no extra cost by emailing us at larollerscarservice@gmail.com or by calling us on <span class="helvetia">+310 270-3561<span>`,
    },
  ],
};

const config = {
  animate: true,
  arrowIcon: "▼",
  // tabFocus: true
};

const styles = {};

export const FaqComponent = () => {
  return (
    <div id="faq" className="faq pb-20 lg:pb-36">
      {/* Заголовок BLOG */}
      <h2 className="text-4xl">BLOG</h2>

      {/* Блок с двумя статьями */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Первая статья: ссылка на /airport-transfer */}
        <Link to="/airport-transfer" className="p-4 rounded hover:bg-gray-100 transition-colors">
          <img
            src="./assets/goson.jpg"
            alt="Airport Transfer LA"
            className="w-full h-auto mb-2"
          />
          <h3 className="text-lg font-bold">Airport Transfer LA</h3>
        </Link>

        {/* Вторая статья: ссылка на /luxury-car-service-la */}
        <Link to="/luxury-car-service-la" className="p-4 rounded hover:bg-gray-100 transition-colors">
          <img
            src="./assets/carservice.jpg"
            alt="Luxury Car Service Los Angeles"
            className="w-full h-auto mb-2"
          />
          <h3 className="text-lg font-bold">Luxury Car Service LA</h3>
        </Link>
      </div>

      {/* Заголовок FAQ */}
      <h2 className="text-4xl mt-16">FAQ</h2>

      {/* Блок с FAQ */}
      <div className="mt-8">
        <Faq data={data} config={config} />
      </div>
    </div>
  );
};
